/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * StatType represents the type of data returned for each asset
 * like energy, feedstock, runningHours.
 *
 */
export var StatType;
(function (StatType) {
    StatType["ENERGY"] = "energy";
    StatType["FEEDSTOCK"] = "feedstock";
    StatType["RUNNING_HOURS"] = "runningHours";
})(StatType || (StatType = {}));
